import type { KyrgyzstanRestPlace } from 'entities/kyrgyzstan/model'
import type { RestPlaceCardItem } from 'entities/kyrgyzstan/ui/rest-places'

export const mapRestPlaceToCardItem = (
  place: KyrgyzstanRestPlace,
): RestPlaceCardItem => ({
  id: place.id,
  title: place.name,
  subtitle: getRestPlaceSubtitle(place),
  image: place.image_url,
})

export const mapRestPlacesToCardItems = (
  places: KyrgyzstanRestPlace[],
): RestPlaceCardItem[] => places.map(mapRestPlaceToCardItem)

export const findRestPlaceByCardItem = (
  places: KyrgyzstanRestPlace[],
  item: RestPlaceCardItem,
): KyrgyzstanRestPlace | undefined =>
  places.find((place) => String(place.id) === String(item.id))

export const getRestPlaceDates = (place: KyrgyzstanRestPlace) => ({
  startDate: getNonEmptyString(place.start_date),
  endDate: getNonEmptyString(place.end_date),
})

const getRestPlaceSubtitle = (place: KyrgyzstanRestPlace): string => {
  const primaryCity = place.cities[0]

  if (!primaryCity) {
    return place.country.country_name
  }

  return [primaryCity.city_name, primaryCity.country_name]
    .filter(Boolean)
    .join(', ')
}

const getNonEmptyString = (value?: string): string | undefined => {
  if (!value?.trim()) {
    return undefined
  }

  return value
}
